import classnames from 'classnames';
import type { FunctionComponent } from 'react';

import { ProductCardSkeleton } from '@/core/tamagoshi/ProductCardSkeleton/ProductCardSkeleton';
import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';

import { PlaylistFilterSkeleton } from '../PlaylistFilterSkeleton/PlaylistFilterSkeleton';
import { SponsoredLabelSkeleton } from '../SponsoredLabelSkeleton/SponsoredLabelSkeleton';

import styles from './RecommendationPlaylistSkeleton.module.scss';

export interface RecommendationPlaylistSkeletonProps {
  withProductCardsLight?: boolean;
  isSponsored?: boolean;
  addToCart?: boolean;
  hasFilters?: boolean;
}

export const RecommendationPlaylistSkeleton: FunctionComponent<
  RecommendationPlaylistSkeletonProps
> = ({ withProductCardsLight, isSponsored, addToCart = false, hasFilters }) => (
  <div className={styles.root}>
    <Skeleton
      className={classnames(styles.title, {
        [styles.titleSponsored]: isSponsored,
      })}
      key="title"
    />

    {isSponsored && <SponsoredLabelSkeleton />}
    {hasFilters && <PlaylistFilterSkeleton />}

    <div className={styles.slider}>
      {['1', '2', '3', '4', '5', '6', '7'].map((item) => (
        <ProductCardSkeleton
          key={`product-card-${item}`}
          vertical
          addToCart={addToCart}
          light={withProductCardsLight}
        />
      ))}
    </div>
  </div>
);
